import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import "assets/css/wrap-image.css";
import { toCdnUrl } from "./to-cdn-url";

const wrapImage = (img: JSX.Element, empty?: boolean) => {
  if (empty) {
    return (
      <div className='border-2 border-dashed border-gray-300 rounded-md mt-2 h-64 items-center justify-center flex text-gray-600'>
        Dcoument/Image not provided
      </div>
    );
  }

  const src = img?.props?.src;
  const rewritten =
    typeof src === "string"
      ? React.cloneElement(img, { src: toCdnUrl(src) })
      : img;

  return <Zoom classDialog='custom-zoom'>{rewritten}</Zoom>;
};

export default wrapImage;
